export default __webpack_public_path__ + "assets/images/74fa116138da4539e58f3403b9944bf6.jpg";